/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Modal, ModalBody, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IDobbiesClubRenewalViewProps } from './dobbies-club-renewal';

export default (props: IDobbiesClubRenewalViewProps) => {
    const { isOpen, heading, onCloseModal, clubRenewalCTA, clubRenewalMessage } = props;

    const clubRenewalPopup = (
        <>
            <ModalHeader>
                <>{heading}</>
                {<button type='button' className='msc-modal__close-button' aria-label='Close' onClick={onCloseModal} />}
            </ModalHeader>
            <ModalBody className='dobbies-club-renewal-popup__body'>
                {clubRenewalMessage}
                {''}
                {clubRenewalCTA}
            </ModalBody>
        </>
    );

    return (
        <Modal
            autoFocus={true}
            fade={false}
            isOpen={isOpen}
            applicationNode={'renderPage'}
            horizontalPosition={'center'}
            verticalPosition={'center'}
            zIndex={5003}
            toggle={onCloseModal}
            modalClassName='dobbies-club-renewal-popup'
            className='dobbies-club-renewal-popup__dialog'
        >
            {clubRenewalPopup}
        </Modal>
    );
};
